const configs = {
    env: process.env.NODE_ENV,
    obeliskApi: process.env.REACT_APP_API_URL,
    obeliskApiAuthKey: process.env.REACT_APP_API_KEY,
    logoutRedirectUrl: '/signin'
    };

export default configs;